import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b145114"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cm-ui-dialog-title",
  style: {"padding-top":"25px"}
}
const _hoisted_2 = { class: "team-manage-wrap" }
const _hoisted_3 = { class: "company-pic cm-ui-mb15" }
const _hoisted_4 = { class: "team" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { style: {"position":"relative","bottom":"5px"} }
const _hoisted_7 = { class: "accounts" }
const _hoisted_8 = { class: "cm-ui-dialog-title" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  class: "cm-ui-dialog-title",
  style: {"padding-top":"25px"}
}
const _hoisted_11 = { class: "team-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_TeamList = _resolveComponent("TeamList")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!

  return (_ctx.activeName === _ctx.ACTIVE_NAME_MAP.viewTeam)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.t('teamManage.switchTeam')), 1),
        _createVNode(_component_el_container, {
          class: "pane",
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/team",
                  monochrome: "",
                  size: 58
                })
              ]),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("label", _hoisted_4, [
                    _createVNode(_component_CmSvgIcon, {
                      class: "label-icon",
                      name: "views/dashboard/_components/central-control/_components/team-manage/_images/team",
                      size: 20
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t('teamManage.teamName')), 1)
                  ]),
                  _createElementVNode("span", {
                    class: "team-name",
                    title: _ctx.activeTeam.name
                  }, _toDisplayString(_ctx.activeTeam.name), 9, _hoisted_5)
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _createVNode(_component_CmSvgIcon, {
                      class: "label-icon",
                      name: "views/dashboard/_components/central-control/_components/team-manage/_images/accounts",
                      size: 20
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.t('teamManage.accountRole')), 1)
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.activeTeam.role_name), 1)
                ])
              ])
            ]),
            _createVNode(_component_el_footer, {
              class: "ft btn-group",
              height: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  size: "small",
                  class: "link",
                  onClick: _ctx.handlerCancelViewTeam
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamManage.back')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.activeTeam.is_creator)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      class: "item",
                      effect: "dark",
                      content: _ctx.leaveTeamDisabledTip,
                      placement: "top-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          plain: "",
                          size: "small",
                          class: "link disable"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('teamManage.leaveThisTeam')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      plain: "",
                      size: "small",
                      class: "link",
                      onClick: _ctx.handlerShowLeaveTeam
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('teamManage.leaveThisTeam')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.handlerSwitchTeam
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamManage.switchToConsole')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64))
    : (_ctx.activeName === _ctx.ACTIVE_NAME_MAP.leaveTeam)
      ? (_openBlock(), _createBlock(_component_el_container, {
          key: 1,
          class: "pane",
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('teamManage.leaveTeamTitle')), 1),
            _createVNode(_component_el_container, { class: "leave-wrap" }, {
              default: _withCtx(() => [
                _createVNode(_component_CmSvgIcon, {
                  name: "views/dashboard/_components/central-control/_components/team-manage/_images/exit_team",
                  class: "cm-ui-mr20",
                  size: 48,
                  "aria-hidden": false,
                  "aria-label": "tip"
                }),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('teamManage.leaveConfirm', { name: _ctx.activeTeam.name })), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_footer, {
              class: "ft cm-ui-txt-rgt",
              height: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "btn",
                  size: "small",
                  onClick: _ctx.handleCancelLeaveTeam
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamManage.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "btn",
                  size: "small",
                  type: "primary",
                  disabled: _ctx.countDown > 0 ? true : false,
                  onClick: _ctx.handleLeaveTeam
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('teamManage.confirmLeave')), 1),
                    (_ctx.countDown)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.t('teamManage.countdownSuffix', { n: _ctx.countDown })), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_el_container, {
          key: 2,
          class: "pane",
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('teamManage.switchTeam')), 1),
            _createVNode(_component_ContentAdaptLayout, { class: "team-wrapper" }, {
              footer: _withCtx(() => [
                (!_ctx.IS_JP_ONLY_BUILD)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      style: {"margin":"20px auto 0"},
                      size: "small",
                      onClick: _ctx.handlerCreateTeam
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('teamManage.createTeam')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TeamList, {
                    "team-list": _ctx.teamList,
                    "show-type": _ctx.TeamListShowType.own,
                    onSelect: _ctx.handlerViewTeam
                  }, null, 8, ["team-list", "show-type", "onSelect"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}